import { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
// import { fetchData } from "@app/Helpers";
// import DOMPurify from "dompurify";
import {
  getUserDetails,
  DETAILS_STALE_TIME,
  DETAILS_CACHE_TIME,
} from "@api/consumer";
// import { ACTIVATION_CACHE_TIME, getActivationDescribe } from "@api/activation";

import { useQuery } from "@tanstack/react-query";
import Button from "@components/Button";
import SectionHeader from "@components/SectionHeader";
import Input from "@components/Input";
import { useForm } from "react-hook-form";
import { registerDevice } from "@api/device";

const INVALID_SERIAL_MESSAGE = "Die eingegebene Seriennummer ist ungültig.";

export default NiceModal.create(() => {
  const modal = useModal();
  const [accessOptionsOpen, setAccessOptionsOpen] = useState(false);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({});

  const detailsQuery = useQuery({
    queryKey: ["user-details"],
    queryFn: () => getUserDetails(),
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
    suspense: false,
  });

  const handleFormSubmit = async (data) => {
    try {
      await registerDevice({
        payload: {
          device: {
            serialNumber: data.serialNumber,
          },
        },
        successCallback: () => {
          detailsQuery.refetch();
          modal.hide();
        },
        errorCallback: (error) => {
          setError("serialNumber", {
            type: "manual",
            message: INVALID_SERIAL_MESSAGE,
          });
        },
      });
    } catch (e) {
      console.error("Unexpected error:", e);
    }
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      disableClose={false}
      onAfterClose={() => modal.remove()}
      innerClass={`connect-modal`}
    >
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="content-wrapper">
          <div className="top-content">
            <SectionHeader>
              <strong>Ultra Insider werden</strong>
            </SectionHeader>
          </div>
          <p className="copy">
            Bitte gib die Seriennummer deines Vuse Ultra Geräts ein – du findest
            sie auf der Rückseite der Originalverpackung.
          </p>
          <p className="copy">
            Falls du sie nicht zur Hand hast, kannst du dein Vuse Ultra Gerät
            auch bequem mit der MYVUSE App koppeln um Ultra Insider zu werden.
          </p>
          <div className="input-wrapper">
            <Input
              disabled={isSubmitting}
              errors={errors["serialNumber"]}
              type={"text"}
              name={"serialNumber"}
              placeholder={""}
              autoComplete={"off"}
              label={"Geräte-Seriennummer"}
              validationRules={{
                required: INVALID_SERIAL_MESSAGE,
              }}
              register={register}
            />
          </div>
          <div className="access-options">
            <button
              type="button"
              className="access-options__toggle"
              aria-expanded={accessOptionsOpen}
              onClick={() => setAccessOptionsOpen((open) => !open)}
            >
              <span>Weitere Möglichkeiten, Zugang zu erhalten</span>
              <svg
                className={`chevron${accessOptionsOpen ? " is-open" : ""}`}
                width="18"
                height="18"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  d="M20 9.54117L18.7454 8L12.0001 13.446L5.2546 8L4 9.54117L12 16L20 9.54117Z"
                  fill="currentColor"
                />
              </svg>
            </button>
            {accessOptionsOpen && (
              <div className="dropdown-text-wrapper">
                <p>
                  Du erhältst automatisch Zugang, wenn du eines der folgenden
                  Kriterien erfüllst:
                </p>
                <ul>
                  <li>
                    In unserem System wurde mindestens ein Kauf von Vuse Ultra
                    Pods registriert.
                  </li>
                  <li>
                    <Link to="/qr-scanner-landing" onClick={() => modal.hide()}>
                      Scanne den QR-Code
                    </Link>{" "}
                    auf einer Ultra Pods-Verpackung.
                  </li>
                </ul>
              </div>
            )}
          </div>
          <Button submit disabled={isSubmitting}>
            Ultra Space freischalten
          </Button>
        </div>
      </form>
    </Modal>
  );
});
